import {NgModule} from '@angular/core';
import {HTMLFragmentModule} from './html/html-fragment.module';

/**
 * Convenience module for re-exporting other DAS Fragment Modules.
 */
@NgModule({
  exports: DasFragmentModule.EXPORTS
})
export class DasFragmentModule {
  public static readonly EXPORTS: any[] = [HTMLFragmentModule];
}
